import React from 'react';
import { render } from 'react-dom';

//other components built
import AsyncBadge from '../../../../badges/AsyncBadge';
import GridColumn from '../../../../services/GridColumn'; //builds ag-grid columns

//filters
import DockRenderer from '../../../../filters/DockRenderer';
import FilterQuickAction from '../../../../filters/FilterQuickAction'; //filter controls
import Select from 'react-select'; //select box for filter
import FilterCountIndicator from '../../../../filters/FilterCountIndicator'
import FilterTray from '../../../../filters/FilterTray'

//highcharts
import CustomBadgeRenderer from '../../../../badges/custom/CustomBadgeRenderer';
import CustomChartRenderer from '../../../../charts/custom/CovidChartRenderer';

import ReactDom from 'react-dom';

//ag grid
import GridRenderer from '../../../../grids/GridRenderer';

//http requests
import axios from 'axios';

//state
import { decorate, observable, computed, action } from 'mobx';
import { observer } from 'mobx-react';

//utility
import { zeroNull, deleteIfEmpty } from '../../../../services/Utilities';
import { grabSystemAliases } from  '../../../../services/SystemAliases';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { processingFunctions, formatFiltersForServer } from '../../../../services/filter_helpers';
import { asyncLoadCharts } from '../../../../services/ChartUtilities';
const _ = require('lodash'); //extra utilities

// Making Instance of class > it's object now
const gridColumns = new GridColumn();

class Dashboard extends React.Component {
  pageId = 208;
  mobxState = {
    cardData: {
      spendCount: 0,
      supplierCount: 0,
      contractCount: 0
    },
    chartRenderData: [],
    tableData: {
      spend_risk_profiles: []
    },
    isLoadingTableData: true,
    selectedModels: {}, //multi select data model for http
    selectedOptions: {}, //multi select data model in filter value/label format
    dockOptions: {
      isVisible: false,
      size: 0.2
    }, //sidebar defaults
    bottomDockOptions: {
      isVisible: false,
      size: 0.2
    },
    pivotData: [],
    pivotState: [],
    pivotFilter: [],
    filterModelNames: [], //autobuilds filters and clear functions
    customFilterModelNames: [],
    filterOptions: {},
    customFilterOptions: {},
    customOptions: {
      savings_opportunity__field_code: "3 Field Code",
      savings_opportunity__savings_potential_percent: "Savings Potential %",
      savings_opportunity__sourcing_event_ease_score: "Sourcing Event Ease Score",
      savings_opportunity__e_auction_ease_score: "E Auction Ease Score",
      savings_opportunity__supplier_availability_score: "Supplier Availability Score",
      grouped_transactions__current_spending: "Current Spend (USD)",
      grouped_transactions__saving_potential: "Savings Potential (USD)",
      spend_risk_profile__name: 'Risk Profile Name',
      grouped_transactions__category_id: 'Category Code',
      grouped_transactions__group: 'Group',
      grouped_transactions__transaction_count: '# of Transactions',
      grouped_transactions__transaction_total: 'Total Spend (USD)',
      grouped_transactions__transaction_avg: 'Avg Transaction (USD)',
      grouped_transactions__supplier_average: 'Supplier Avg (USD)',
      grouped_transactions__industry_average: 'Industry Avg (USD)',
      grouped_transactions__percent_of_average: 'Difference (%)',
    },
    filtersForServer: {} // Filters in normal form to use for the server
  };

  //mount data through http requests
  componentDidMount() {
    //call the data loader to load data into the view
    this.fetchData();
  }

  //////////////////HTTP/////////////////
  //helpers for system filters
  //helpers for custom filters
  //setup filters
  // TODO:
  // - Remove system filters from customOptions once we have api call to populate aliases in place
  setupFilters = async () => {
    const urls = {
      system: '/v1/system_filters',
      systemOptions: '/v1/transactions/system_field_options',
      custom: '/v1/custom_filters_formatted',
      customOptions: '/v1/transactions/custom_field_options',
      systemOptionsSearchUrl: `/v1/transactions/system_field_options`,
      customOptionsSearchUrl: `/v1/transactions/custom_field_options`
    };
    const [systemFilterResp, customFilterResp] = await Promise.all([
      axios.get(urls.system, {
        params: processingFunctions.system.filters.formatParams({
          enabled: true,
          page_id: this.pageId
        })
      }),
      axios.get(urls.custom, {
        params: processingFunctions.custom.filters.formatParams({
          enabled: true,
          page_id: this.pageId
        })
      })
    ]);


    let systemFilters = processingFunctions.system.filters.formatResp(systemFilterResp);
    let customFilters = processingFunctions.custom.filters.formatResp(customFilterResp);

    // Handle System Filters First
    let systemFilterModelNames = [];
    let systemFilterOptions = {};
    let systemFilterCustomOptions = {};
    let systemFilterWidgetTypes = {};

    systemFilters
      .filter(filter => filter.enabled)
      .forEach(filter => {
        let { name, widget_type } = filter; // Name of filter in the table, usually this is the column name of the sequelize model as well
        systemFilterModelNames.push(name); // Construct Select
        systemFilterWidgetTypes[name] = widget_type;
      });

    // Get options (name-label format) for our selects in model-nested format
    // then convert it to name-label format
    systemFilterOptions = await axios
      .post(
        urls.systemOptions,
        processingFunctions.system.options.formatParams({
          selected_filters: this.mobxState.filtersForServer,
          system_fields: systemFilterModelNames
        })
      )
      .then(processingFunctions.system.options.formatResp);

    // Then Handle Custom Filters
    let customFilterModelNames = [];
    let customFilterOptions = {};
    let customFilterCustomOptions = {};
    let customFilterWidgetTypes = {};

    // Manipulate custom filters into a format where they can be handled
    // by the constructors for our filter panel
    customFilters.forEach(filter => {
      let [name, data] = _.toPairs(filter)[0]; // _.toPairs splits object into list of [key, value] pairs
      customFilterModelNames.push(name);
      customFilterCustomOptions[name] = data.field_alias; // Construct the filter
      customFilterWidgetTypes[name] = data.widget_type;
    });

    customFilterOptions = await axios
      .post(
        urls.customOptions,
        processingFunctions.custom.options.formatParams({
          selected_filters: this.mobxState.filtersForServer,
          custom_fields: customFilterModelNames
        })
      )
      .then(processingFunctions.custom.options.formatResp);

    // ------------------------------------------------------------
    // Finally Setup The Filters
    // Use the current filter generation that gets triggered when filterModelNames change
    this.mobxState.filterModelNames = systemFilterModelNames;
    this.mobxState.customFilterModelNames = customFilterModelNames;

    this.mobxState.filterOptions = systemFilterOptions;
    this.mobxState.customFilterOptions = customFilterOptions;

    this.mobxState.filterWidgetTypes = systemFilterWidgetTypes;
    this.mobxState.customFilterWidgetTypes = customFilterWidgetTypes;

    this.mobxState.customOptions = {
      ...this.mobxState.customOptions,
      ...systemFilterCustomOptions,
      ...customFilterCustomOptions
    };
    this.mobxState.optionSearchFunctions = processingFunctions.general.makeSearchFunctions({
      system_filters: systemFilters,
      custom_filters: customFilters,
      system_url: urls.systemOptionsSearchUrl,
      custom_url: urls.customOptionsSearchUrl,
      selected_filters: this.mobxState.filtersForServer,
      system_fields: systemFilterModelNames,
      custom_fields: customFilterModelNames
    });
  };
  //data loader
  fetchData = () => {
    // Restore filters
    this.mobxState.selectedModels = JSON.parse(localStorage.getItem('selectedModels')) || {}; //multi select data model for http
    this.mobxState.selectedOptions = JSON.parse(localStorage.getItem('selectedOptions')) || {}; //multi select data model in filter value/label format
    this.mobxState.filtersForServer = JSON.parse(localStorage.getItem('filtersForServer')) || {};
    //quick workaround -- pull simple dropdown value from nested component instead of passing around state
    var table_rows = window.$('#table_rows_dropdown').val();
    //merge the filter model with the amount of rows selected
    this.setupFilters();

    //merge the filter model with the amount of rows selected
    let models_with_rows = {
      ...this.mobxState.filtersForServer,
      ...{ table_rows: table_rows || [] }
    };

    //custom pivot configurations load
    axios
      .get('/v1/resources/index_filter', { params: { page_id: this.pageId } })
      .then(response => {
        this.mobxState.pivotFilter = response.data.resources;
      })
      .catch(console.log.bind(console)); //error catcher

    //analytics data load
    this.mobxState.cardDataLoading = true;
    axios.post('/v1/outlier_analytics_overview_analytics', models_with_rows).then(response => {
      this.mobxState.cardData = response.data.transaction_analytics;
      this.mobxState.cardDataLoading = false;
    });

    //load custom chart data for this page (updates mobxState.chartRenderData)
    asyncLoadCharts(this.mobxState, {
        page_id: this.pageId,
        selected_models: this.mobxState.filtersForServer
    });
      //set up custom options for components, then get data for components
      // axios.get("/v1/ref_cmfields_labels")
      // Merge System Aliases Into Custom Options (Keeping existing values)
      grabSystemAliases().then(systemAliases => {
        this.mobxState.customOptions = {
          ...systemAliases,
          ...(this.mobxState.customOptions || {}), // Prefer existing values
        }
      });

      axios
        .get('/v1/custom_schemas', { params: { name: 'category' } }) //query the project custom field schema for all projects
        .then(response => {
          //get map of field labels from API
          this.mobxState.customSchema = response.data;

          // Add them into customOptions
          // TODO: Remove this when we have aliases properly working
          Object.keys(
            (this.mobxState.customSchema.custom_schemas[0] &&
              this.mobxState.customSchema.custom_schemas[0].schema_definition) ||
              {}
          ).map(field => {
            let k = 'category__' + field;
            let v = this.mobxState.customSchema.custom_schemas[0].schema_definition[field].field_alias;
            this.mobxState.customOptions[k] = v;
          });

          //after ag grid is set up, get the rest of the data
          //table data load
          this.mobxState.isLoadingTableData = true;
          axios.post('/v1/outlier_analytics_overview', models_with_rows).then(response => {
            this.mobxState.tableData = response.data;
            this.mobxState.isLoadingTableData = false;
            //set the column definitions for ag grid, look into buildColumnDefs class to see options
            this.mobxState.columnDefsTransactions = gridColumns.buildColumnDefs({
              customOptions: this.mobxState.customOptions,
              columnArray: ['outlier_analysis_overview'],
              customFieldSchema: this.mobxState.customSchema.custom_schemas[0] || {},
              dataType: 'outlier_analysis_overview', //special tag to signify that this is project data
              metadata: {
                supplier_name_handler: (event) => {this.handleFilter('supplier__name', [{label: event.value, value: event.value}])},
                item_description_handler: (event) => {this.handleFilter('transaction__item_description', [{label: event.value, value: event.value}])},
                percent_of_average: {
                  'min': Math.max(response.data.grouped_transactions && Math.min(...response.data.grouped_transactions.map(x => x.percent_of_average)), 0),
                  'max': response.data.grouped_transactions && Math.max(...response.data.grouped_transactions.map(x => x.percent_of_average))
                }
              }
            });
            //call child function to autofit child columns
            this.autofitChild();
          });
        })
  }; //end fetchData() ///////////////
  deleteRequest = toSendArr => {};
  //////////////////END HTTP/////////////////
  handleChartFilter = (filterParam, selectedFilter) => {
    // KLUDGE : If the filterParam begins with 'custom_fields.' then it should be treated as if
    // a custom_filter was selected
    if (filterParam.indexOf('custom_fields.') !== -1) {
      return this.handleCustomFilter(filterParam.replace(/custom_fields./, ''), selectedFilter);
    } else {
      return this.handleFilter(filterParam, selectedFilter);
    }
  };

  //handles dropdown and chart filters
  handleFilter = (filterParam, selectedFilter) => {
    // In the state, pick the model based on filter that is sent and turn it into the array of values of the filter.
    // This goes as params to http request
    // Update state with selected options, removing the property if none selected
    // Equivalent to this.mobxState[filterParam] = selectedFilter.map(a => a.value)
    // but handles nested assignment
    this.mobxState.selectedModels[filterParam] = selectedFilter.map(a => a.value);
    deleteIfEmpty(this.mobxState.selectedModels, filterParam);

    //also store the selections in the original form. This goes back to the filter as selected values
    this.mobxState.selectedOptions[filterParam] = selectedFilter;
    if (_.isEmpty(this.mobxState.selectedOptions[filterParam])) {
      delete this.mobxState.selectedOptions[selectedFilter];
    }
    // Update which filters for params
    this.mobxState.filtersForServer = formatFiltersForServer(this.mobxState.selectedModels);

    // Update stored filters
    localStorage.setItem('selectedOptions', JSON.stringify(this.mobxState.selectedOptions));
    localStorage.setItem('filtersForServer', JSON.stringify(this.mobxState.filtersForServer));
    localStorage.setItem('selectedModels', JSON.stringify(this.mobxState.selectedModels));
    //fetch called, it reads the filter params from state
    this.fetchData();
  };

  handleCustomFilter = (filterParam, selectedFilter) => {
    //in the state, pick the model based on filter that is sent and turn it into the array of values of the filter. This goes as params to http request
    this.mobxState.selectedModels['custom_fields'] = this.mobxState.selectedModels['custom_fields'] || {};
    this.mobxState.selectedModels['custom_fields'][filterParam] = selectedFilter.map(a => a.value);
    deleteIfEmpty(this.mobxState.selectedModels, `custom_fields.${filterParam}`);
    deleteIfEmpty(this.mobxState.selectedModels, `custom_fields`);

    //also store the selections in the original form. This goes back to the filter as selected values
    this.mobxState.selectedOptions['custom_fields'] = this.mobxState.selectedOptions['custom_fields'] || {};
    this.mobxState.selectedOptions.custom_fields[filterParam] = selectedFilter;
    deleteIfEmpty(this.mobxState.selectedOptions, `custom_fields.${filterParam}`);
    deleteIfEmpty(this.mobxState.selectedOptions, `custom_fields`);
    // Update which filters for params
    this.mobxState.filtersForServer = formatFiltersForServer(this.mobxState.selectedModels);
    // Update stored filters
    localStorage.setItem('selectedOptions', JSON.stringify(this.mobxState.selectedOptions));
    localStorage.setItem('filtersForServer', JSON.stringify(this.mobxState.filtersForServer));
    localStorage.setItem('selectedModels', JSON.stringify(this.mobxState.selectedModels));

    //fetch called, it reads the filter params from state
    this.fetchData();
  };
  //handles dropdown and chart filters
  handleClear = () => {
    //in the state, clear the model. This goes as params to http request
    this.mobxState.selectedModels = {};

    // Clear the filters we send to the server
    this.mobxState.filtersForServer = {};

    //also store the explicit cleared selections in the original form. This goes back to the filter as selected values
    //loop below takes array of column names and attaches blank arrays to them to explicitly clear the filter
    //from ["supplier", "item"] to {"supplier":[], "item":[]}
    let newSelectedOptions = { custom_fields: {} };
    this.mobxState.filterModelNames.forEach(name => {
      newSelectedOptions[name] = [];
    });
    this.mobxState.customFilterModelNames.forEach(name => {
      newSelectedOptions.custom_fields[name] = [];
    });
    this.mobxState.selectedOptions = newSelectedOptions;
    localStorage.setItem('selectedOptions',  '{}');
    localStorage.setItem('filtersForServer', '{}');
    localStorage.setItem('selectedModels',  '{}');

    //fetch called, it reads the filter params from state
    this.fetchData();
  };

  //for sidebar dock to change sizes
  handleSizeChange = size => {
    this.mobxState.dockOptions.size = size;
  };

  //sidebar dock toggle
  toggleDock = () => {
    this.mobxState.dockOptions.isVisible = !this.mobxState.dockOptions.isVisible;
  };
  toggleBottomDock = () => {
    this.mobxState.bottomDockOptions.isVisible = !this.mobxState.bottomDockOptions.isVisible;
  }

  render() {
    const hcHeight = '300px';

    return (
      <div>
        {/* Small Left Toggle */}
        <div onClick={this.toggleDock} className='sidebar_button filter_toggle'>
          <i className='glyphicon glyphicon-chevron-left'></i>
        </div>
        <div
          className='jumbotron jumbotron_full_width'
          style={{ maxHeight: '71.5px', overflow: 'visible', whiteSpace: 'nowrap' }}
        >
          <div className='jumbotron_full_width_container'>
            <div className='row'>
              <div className='col-sm-12'>
                <span className='fa-layers fa-fw fa-2x'>
                  <FontAwesomeIcon
                    icon={['fas', 'circle']}
                    transform='grow-3'
                    color='#009C9C'
                    style={{ marginTop: '4px' }}
                  />
                  <FontAwesomeIcon
                    icon={['fal', 'folders']}
                    color='white'
                    transform='shrink-5'
                    style={{ marginTop: '3px' }}
                  />
                </span>
                &nbsp;
                <b className='dash_header'>Outliers </b>
                <FilterCountIndicator
                  handleClick={this.toggleBottomDock}
                  selectedModels={this.mobxState.selectedModels}/>
                <span style={{ minWidth: '28.608vw', float: 'right' }}>
                  {/* Conditionally rendered dropdown if project exists or else it will display "create a project" text*/}
                </span>
              </div>
            </div>
            <FilterTray
              isVisible={this.mobxState.bottomDockOptions.isVisible}
              handleToggleDock={this.toggleBottomDock}
              selectedModels={this.mobxState.selectedModels}
              customOptions={this.mobxState.customOptions}
              />
            <br/>
          </div>
        </div>
        {/* BADGES */}
        <div className='row'>
          <CustomBadgeRenderer
            handleFilter={this.handleChartFilter}
            toggleDock={this.toggleDock}
            handleClear={this.handleClear}
            chartRenderData={this.mobxState.chartRenderData}
          />
        </div>
        <br />
        {/* SUMMARY CHARTS */}
        <div className='row'>
          <CustomChartRenderer
            handleFilter={this.handleChartFilter}
            toggleDock={this.toggleDock}
            handleClear={this.handleClear}
            chartRenderData={this.mobxState.chartRenderData}
          />
        </div>{' '}
        {/* END ROW */}
        {/* END SUMMARY CHARTS */}
        {/* Select Filter allows you to select the pivot_settings config to display*/}
        <div className="row">
          <div className="col-sm-12">
            <div className="panel panel-default">
              <div className="panel-heading panel_bg">
                <b>Saved Outlier Analytics Configurations</b>
              </div>
              <div className="panel-body">
              {/* NEED TO GIVE THIS PROPER DATA AND DEFAULT VALUES*/}
                <Select
                  onChange={(e) => this.clickChild(e)}
                  options={this.mobxState.pivotFilter}
                  closeMenuOnSelect={true}
                  maxMenuHeight = {400}
                  placeholder={'Select From List of Outlier Analytics Tables'}
                />
              </div>
            </div>
          </div>
        </div>
        {/* PROJECT GRID */}
        <div className='row'>
          <div className='col-lg-12'>
            {/* AG Grid */}
            <GridRenderer
              gridHeight={'650px'}
              columnDefs={this.mobxState.columnDefsTransactions}
              rowData={this.mobxState.tableData.grouped_transactions}
              fetchData={this.fetchData}
              handleClear={this.handleClear}
              toggleDock={this.toggleDock}
              pageId={this.pageId}
              savedState={this.mobxState.pivotState}
              isPivotMode={true}
              gridTitle={'Outlier Spending'}
              setClick={click => (this.clickChild = click)}
              deleteRequest={this.deleteRequest}
              idColumn={'id'}
              modelsToUpdateArr={[{ url: 'v1/transactions_index' }]}
              //modelsToUpdateArr={false}
              enableSetResizeChild={true}
              setResize={click => this.autofitChild = click}
              // enableSetResizeChildColumns={true}
              // setResizeToColumnWidth={click => this.autofitChildToColumnWidth = click}

              singleClickEdit={true}
              suppressClickEdit={false}
              isSaveable={true}
              isAwardable={false}
              isDeletable={false}
              isLoadingTableData={this.mobxState.isLoadingTableData}
            />
          </div>
        </div>
        <br />
        {/* Sidebar */}
        <DockRenderer
          position={'right'}
          size={this.mobxState.dockOptions.size}
          dimMode={'none'}
          isVisible={this.mobxState.dockOptions.isVisible}
          onVisibleChange={this.handleVisibleChange}
          onSizeChange={this.handleSizeChange}
          fluid={true}
          toggleDock={this.toggleDock}
          handleClear={this.handleClear}
          // Current Filters----------------------------------
          value={this.mobxState.selectedOptions}
          // Select Names-------------------------------------
          filterModelNames={this.mobxState.filterModelNames}
          customFilterModelNames={this.mobxState.customFilterModelNames}
          // Widget Types-------------------------------------
          filterWidgetTypes={this.mobxState.filterWidgetTypes}
          customFilterWidgetTypes={this.mobxState.customFilterWidgetTypes}
          // Options------------------------------------------
          options={this.mobxState.filterOptions}
          customFilterOptions={this.mobxState.customFilterOptions}
          // Handlers-----------------------------------------
          handleFilter={this.handleFilter}
          handleCustomFilter={this.handleCustomFilter}
          // Search Functions --------------------------------
          optionSearchFunctions={this.mobxState.optionSearchFunctions}
          // Visual options-----------------------------------
          customOptions={this.mobxState.customOptions}
          // Callbacks----------------------------------------
          closeMenuOnSelect={true}
          maxMenuHeight={400}
        />
      </div>
    );
  }
}

// when using decorate, all fields should be specified (a class might have many more non-observable internal fields after all)
decorate(Dashboard, {
  mobxState: observable
});

export default observer(Dashboard);

// export default Dashboard;
